import EnvelopeIcon from "@heroicons/react/24/solid/EnvelopeIcon";
import PhoneIcon from "@heroicons/react/24/solid/PhoneIcon";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import Check from "@mui/icons-material/Check";
import { MenuItem } from "@mui/material";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import PhoneInput from "react-phone-number-input";
import Color from "../../../assets/colors";

export const DialogContainer = styling(Dialog)((props) => ({
  ".MuiDialog-paper": {
    borderRadius: "1rem",
    overflowX: "clip",
    minWidth: "1322px",
    margin: "0 0.4rem",
    maxHeight: "640px",
    border: "1px solid #707070",
  },

  [props.theme.breakpoints.down("1280")]: {
    "& .MuiDialog-paper": {
      minWidth: "328px",
    },
  },

  [props.theme.breakpoints.down("767")]: {
    "& .MuiDialog-paper": {
      maxHeight: "620px",
    },
  },
}));

export const CardContainer = styling(Box)({
  minWidth: "37.5rem",
  width: "100%",
  height: "100%",

  overflow: "clip",

  "@media (max-width: 640px)": {
    minWidth: "330px",
  },
});

export const BoxContainer = styling(Box)({
  display: "flex",
  width: "100%",

  "@media (max-width: 640px)": {
    padding: "8px",
    minWidth: "330px",
  },
});

export const InnerScrollContainer = styling(Box)({
  width: "100%",
  minHeight: "515px",
  overflowY: "scroll",

  "@media (max-width: 1280px)": {
    maxHeight: "500px",
    height: "100%",
    padding: "8px 8px 52px",
    overflowY: "scroll",
  },

  "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
    backgroundColor: "transparent",
    width: 0,
    overflow: "auto",
  },
  "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
    borderRadius: 8,
    backgroundColor: "transparent",
    overflow: "auto",
  },
  "&::-webkit-scrollbar-track": {
    height: "3.25rem",
  },
});

export const ScrollTextContainer = styling(Box)({
  display: "flex",
  width: "100%",
  justifyContent: "center",
  paddingTop: "32px",

  "@media (max-width: 1280px)": {
    width: "auto",
    borderTop: "1px solid #512ACC33",
    margin: "16px 16px 0px 16px",
    paddingTop: "16px",
  },
});

export const ScrollContainer = styling(Box)({
  display: "flex",
  width: "100%",
  height: "640px",
  padding: "40px 40px 32px 40px",

  "@media (max-width: 1280px)": {
    maxHeight: "612px",
    height: "auto",
    padding: "8px",
  },

  "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
    backgroundColor: "transparent",
    width: 0,
    overflow: "auto",
  },
  "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
    borderRadius: 8,
    backgroundColor: "transparent",
    overflow: "auto",
  },
  "&::-webkit-scrollbar-track": {
    height: "3.25rem",
  },
});

export const TextStyled = styling(Typography)({});

export const TextFieldStyled = styling(TextField)({
  width: "100%",

  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderRadius: "0.5rem",
      border: `2px solid ${Color.grey}`,
      transition: "all 0.15s ease-in-out",
    },

    "&:hover fieldset": {
      border: `2px solid ${Color.hiredlyPurple}`,
    },

    "&.Mui-focused fieldset": {
      border: `2px solid ${Color.hiredlyPurple}`,
    },

    "@media (max-width: 640px)": {
      fontSize: "0.875rem",
    },
  },
  "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: Color.error,
  },
});

export const PhoneInputStyled = styling(PhoneInput)((props) => ({
  display: "flex",
  alignItems: "center",

  border: props?.error ? `2px solid ${Color.error}` : `2px solid ${Color.grey}`,
  borderRadius: "0.5rem",
  padding: "0.875rem",
  width: "16.75rem",
  height: "3rem",

  overflow: "clip",

  "@media (max-width: 640px)": {
    width: "auto",
    height: "2.5rem",
    padding: "0.5rem",
  },

  "& .PhoneInputInput": {
    fontFamily: "Inter",
    fontSize: "1rem",
    flex: "1",
    height: "100%",
    border: "none",

    "@media (max-width: 640px)": {
      fontSize: "0.875rem",
    },
  },

  "& .PhoneInputInput:focus": {
    outline: "none",
  },

  "& .PhoneInputCountryIconImg": {
    width: "24px",
    height: "100%",
    borderRadius: "0.3rem",
  },

  "& .PhoneInputInternationalIconPhone": {
    opacity: "0.8",
  },

  "& .PhoneInputInternationalIconGlobe": {
    opacity: "0.65",
  },

  "& .PhoneInputCountry": {
    position: "relative",
    alignSelf: "stretch",
    display: "flex",
    alignItems: "center",
    margin: "0.3em 0 0 0.35em",
  },

  "& .PhoneInputCountrySelect": {
    position: "absolute",
    top: "0",
    left: "0",
    height: "100%",
    width: "100%",
    zIndex: "1",
    border: "0",
    opacity: "0",
    cursor: "pointer",
  },

  "& .PhoneInputCountrySelectArrow": {
    display: "block",
    content: '""',
    width: "0.3em",
    height: "0.3em",
    margin: "0 0.25em 0.4em 0.35em",
    borderStyle: "solid",
    borderColor: "inherit",
    borderTopWidth: "0",
    borderBottomWidth: "1px",
    borderLeftWidth: "0",
    borderRightWidth: "1px",
    transform: "rotate(45deg)",
    opacity: "0.45",
  },
}));

export const CheckboxStyled = styling(Checkbox)({
  padding: "0rem",
  "& .Mui-checked": {
    color: Color.black,
  },

  "&:hover": {
    background: "transparent",
  },
});

export const SelectStyled = styling(Select)({
  width: "100%",

  "&.MuiOutlinedInput-root": {
    maxHeight: "3rem",
    fieldset: {
      borderRadius: "0.5rem",
      border: `2px solid ${Color.grey}`,
      transition: "all 0.15s ease-in-out", // Default border thickness
    },
    "&.MuiOutlinedInput-notchedOutline": {
      border: `2px solid ${Color.hiredlyPurple}`,
    },
    "&:hover": {
      fieldset: {
        border: `2px solid ${Color.hiredlyPurple}`,
      },
    },
    "&.Mui-focused": {
      fieldset: {
        border: `2px solid ${Color.hiredlyPurple}`,
      },
    },

    "@media (max-width: 640px)": {
      fontSize: "0.875rem",
      maxHeight: "2.5rem",
    },
  },
});

export const OptionStyled = styling(MenuItem)({});

export const CloseButton = styling(ButtonBase)({});

export const ButtonStyled = styling(ButtonBase)({
  fontSize: "12px",
  fontWeight: "700",
  fontFamily: "Inter",
  width: "98px",
  padding: "0px 16px 0px 16px",
  height: "40px",

  backgroundColor: Color.black,
  color: Color.white,

  borderRadius: "0.5rem",

  transition: "all 0.15s ease-in-out",

  ":disabled": {
    opacity: "0.5",
  },
});

export const CloseIcon = styling(XMarkIcon)({
  height: "24px",
  width: "24px",
});

export const CallIcon = styling(PhoneIcon)({
  height: "16px",
  width: "16px",
});

export const EmailIcon = styling(EnvelopeIcon)({
  height: "16px",
  width: "16px",
});

export const UncheckedIcon = styling(Box)({
  width: "32px",
  height: "32px",
  borderRadius: "0.5rem",
  border: `2px solid ${Color.grey}`,
});

export const CheckedIcon = styling(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  width: "32px",
  height: "32px",
  borderRadius: "0.5rem",
  border: `2px solid ${Color.grey}`,
  backgroundColor: Color.black,
});

export const CheckStyled = styling(Check)({
  color: Color.white,
});
